"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "AccountDeletionConfirmationWrapper", {
  enumerable: true,
  get: function get() {
    return _account_deletion_confirmation_wrapper["default"];
  }
});
Object.defineProperty(exports, "AdvancedFiltersWrapper", {
  enumerable: true,
  get: function get() {
    return _advanced_filters_wrapper["default"];
  }
});
Object.defineProperty(exports, "AnimatedProgressBarWrapper", {
  enumerable: true,
  get: function get() {
    return _animated_progress_bar_wrapper["default"];
  }
});
Object.defineProperty(exports, "AnswerCardWrapper", {
  enumerable: true,
  get: function get() {
    return _answer_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "ArrowBoxWrapper", {
  enumerable: true,
  get: function get() {
    return _arrow_box_wrapper["default"];
  }
});
Object.defineProperty(exports, "AudioPlayerWrapper", {
  enumerable: true,
  get: function get() {
    return _audio_player_wrapper["default"];
  }
});
Object.defineProperty(exports, "BadgeCollectionWrapper", {
  enumerable: true,
  get: function get() {
    return _badge_collection_wrapper["default"];
  }
});
Object.defineProperty(exports, "BadgeWrapper", {
  enumerable: true,
  get: function get() {
    return _badge_wrapper["default"];
  }
});
Object.defineProperty(exports, "BannerNoticesIndexWrapper", {
  enumerable: true,
  get: function get() {
    return _banner_notices_index_wrapper["default"];
  }
});
Object.defineProperty(exports, "BannerNoticesShowWrapper", {
  enumerable: true,
  get: function get() {
    return _banner_notices_show_wrapper["default"];
  }
});
Object.defineProperty(exports, "BorderRadius", {
  enumerable: true,
  get: function get() {
    return _border_radius["default"];
  }
});
Object.defineProperty(exports, "BulkEditReviewsWrapper", {
  enumerable: true,
  get: function get() {
    return _bulk_edit_reviews_wrapper["default"];
  }
});
Object.defineProperty(exports, "CardArrowBoxWrapper", {
  enumerable: true,
  get: function get() {
    return _card_arrow_box_wrapper["default"];
  }
});
Object.defineProperty(exports, "CardButtonWrapper", {
  enumerable: true,
  get: function get() {
    return _card_button_wrapper["default"];
  }
});
Object.defineProperty(exports, "CardIconsWrapper", {
  enumerable: true,
  get: function get() {
    return _card_icons_wrapper["default"];
  }
});
Object.defineProperty(exports, "CardNoteWrapper", {
  enumerable: true,
  get: function get() {
    return _card_note_wrapper["default"];
  }
});
Object.defineProperty(exports, "CardReviewToggleWrapper", {
  enumerable: true,
  get: function get() {
    return _card_review_toggle_wrapper["default"];
  }
});
Object.defineProperty(exports, "CardSectionWrapper", {
  enumerable: true,
  get: function get() {
    return _card_section_wrapper["default"];
  }
});
Object.defineProperty(exports, "CardSourceListWrapper", {
  enumerable: true,
  get: function get() {
    return _card_source_list_wrapper["default"];
  }
});
Object.defineProperty(exports, "CardTextWrapper", {
  enumerable: true,
  get: function get() {
    return _card_text_wrapper["default"];
  }
});
Object.defineProperty(exports, "CardTypeSelectWrapper", {
  enumerable: true,
  get: function get() {
    return _card_type_select_wrapper["default"];
  }
});
Object.defineProperty(exports, "CardUserInputWrapper", {
  enumerable: true,
  get: function get() {
    return _card_user_input_wrapper["default"];
  }
});
Object.defineProperty(exports, "CardWordTextWrapper", {
  enumerable: true,
  get: function get() {
    return _card_word_text_wrapper["default"];
  }
});
Object.defineProperty(exports, "CaseFillInTheBlanksCardWrapper", {
  enumerable: true,
  get: function get() {
    return _case_fill_in_the_blanks_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "CaseIntroCardWrapper", {
  enumerable: true,
  get: function get() {
    return _case_intro_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "CaseMultipleChoiceCardWrapper", {
  enumerable: true,
  get: function get() {
    return _case_multiple_choice_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "CheckpointCardWrapper", {
  enumerable: true,
  get: function get() {
    return _checkpoint_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "CommentCreateWrapper", {
  enumerable: true,
  get: function get() {
    return _comment_create_wrapper["default"];
  }
});
Object.defineProperty(exports, "CommentHistoryWrapper", {
  enumerable: true,
  get: function get() {
    return _comment_history_wrapper["default"];
  }
});
Object.defineProperty(exports, "CommentIndexWrapper", {
  enumerable: true,
  get: function get() {
    return _comment_index_wrapper["default"];
  }
});
Object.defineProperty(exports, "CommentShowWrapper", {
  enumerable: true,
  get: function get() {
    return _comment_show_wrapper["default"];
  }
});
Object.defineProperty(exports, "CompositeVideoPlayerWrapper", {
  enumerable: true,
  get: function get() {
    return _composite_video_player_wrapper["default"];
  }
});
Object.defineProperty(exports, "ComprehendCardWrapper", {
  enumerable: true,
  get: function get() {
    return _comprehend_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "ConjugationCardPromptWrapper", {
  enumerable: true,
  get: function get() {
    return _conjugation_card_prompt_wrapper["default"];
  }
});
Object.defineProperty(exports, "ConjugationCardRevealedWrapper", {
  enumerable: true,
  get: function get() {
    return _conjugation_card_revealed_wrapper["default"];
  }
});
Object.defineProperty(exports, "ConjugationCardWrapper", {
  enumerable: true,
  get: function get() {
    return _conjugation_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "ConjugationTableCardWrapper", {
  enumerable: true,
  get: function get() {
    return _conjugation_table_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "ConjugationTableWrapper", {
  enumerable: true,
  get: function get() {
    return _conjugation_table_wrapper["default"];
  }
});
Object.defineProperty(exports, "ContentLinkWrapper", {
  enumerable: true,
  get: function get() {
    return _content_link_wrapper["default"];
  }
});
Object.defineProperty(exports, "CorrectCardsStatusWrapper", {
  enumerable: true,
  get: function get() {
    return _correct_cards_status_wrapper["default"];
  }
});
Object.defineProperty(exports, "DailyActivityCalendarDayWrapper", {
  enumerable: true,
  get: function get() {
    return _daily_activity_calendar_day_wrapper["default"];
  }
});
Object.defineProperty(exports, "DailyActivityWrapper", {
  enumerable: true,
  get: function get() {
    return _daily_activity_wrapper["default"];
  }
});
Object.defineProperty(exports, "DeckCardContext", {
  enumerable: true,
  get: function get() {
    return _video_player_wrapper.DeckCardContext;
  }
});
Object.defineProperty(exports, "DeckCloseNativeWrapper", {
  enumerable: true,
  get: function get() {
    return _deck_close_native_wrapper["default"];
  }
});
Object.defineProperty(exports, "DeckCloseWebWrapper", {
  enumerable: true,
  get: function get() {
    return _deck_close_web_wrapper["default"];
  }
});
Object.defineProperty(exports, "DeckHistoryWrapper", {
  enumerable: true,
  get: function get() {
    return _deck_history_wrapper["default"];
  }
});
Object.defineProperty(exports, "DeckLinkWrapper", {
  enumerable: true,
  get: function get() {
    return _deck_link_wrapper["default"];
  }
});
Object.defineProperty(exports, "DeckMenuWrapper", {
  enumerable: true,
  get: function get() {
    return _deck_menu_wrapper["default"];
  }
});
Object.defineProperty(exports, "DeckProgressBarWrapper", {
  enumerable: true,
  get: function get() {
    return _deck_progress_bar_wrapper["default"];
  }
});
Object.defineProperty(exports, "DeckRatingWrapper", {
  enumerable: true,
  get: function get() {
    return _deck_rating_wrapper["default"];
  }
});
Object.defineProperty(exports, "DeckSettingsWrapper", {
  enumerable: true,
  get: function get() {
    return _deck_settings_wrapper["default"];
  }
});
Object.defineProperty(exports, "DeckSummaryCardWrapper", {
  enumerable: true,
  get: function get() {
    return _deck_summary_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "DeckWrapper", {
  enumerable: true,
  get: function get() {
    return _deck_wrapper["default"];
  }
});
Object.defineProperty(exports, "DescribeCardWrapper", {
  enumerable: true,
  get: function get() {
    return _describe_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "DictionarySentencesWrapper", {
  enumerable: true,
  get: function get() {
    return _dictionary_sentences_wrapper["default"];
  }
});
Object.defineProperty(exports, "EvaluateButtonsWrapper", {
  enumerable: true,
  get: function get() {
    return _evaluate_buttons_wrapper["default"];
  }
});
Object.defineProperty(exports, "ExampleSentenceTranslationProvider", {
  enumerable: true,
  get: function get() {
    return _example_sentence_translation.ExampleSentenceTranslationProvider;
  }
});
Object.defineProperty(exports, "ExerciseCardWrapper", {
  enumerable: true,
  get: function get() {
    return _exercise_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "ExerciseCreateWrapper", {
  enumerable: true,
  get: function get() {
    return _exercise_create_wrapper["default"];
  }
});
Object.defineProperty(exports, "ExerciseMatchMediaWrapper", {
  enumerable: true,
  get: function get() {
    return _exercise_match_media_wrapper["default"];
  }
});
Object.defineProperty(exports, "ExerciseMultipleChoiceMediaWrapper", {
  enumerable: true,
  get: function get() {
    return _exercise_multiple_choice_media_wrapper["default"];
  }
});
Object.defineProperty(exports, "ExerciseReorderWrapper", {
  enumerable: true,
  get: function get() {
    return _exercise_reorder_wrapper["default"];
  }
});
Object.defineProperty(exports, "FaqCategoryShowWrapper", {
  enumerable: true,
  get: function get() {
    return _faq_category_show_wrapper["default"];
  }
});
Object.defineProperty(exports, "FaqItemShowWrapper", {
  enumerable: true,
  get: function get() {
    return _faq_item_show_wrapper["default"];
  }
});
Object.defineProperty(exports, "FaqWrapper", {
  enumerable: true,
  get: function get() {
    return _faq_wrapper["default"];
  }
});
Object.defineProperty(exports, "FeedEntryIndexWrapper", {
  enumerable: true,
  get: function get() {
    return _feed_entry_index_wrapper["default"];
  }
});
Object.defineProperty(exports, "FeedEntryWrapper", {
  enumerable: true,
  get: function get() {
    return _feed_entry_wrapper["default"];
  }
});
Object.defineProperty(exports, "FeedInfoWrapper", {
  enumerable: true,
  get: function get() {
    return _feed_info_wrapper["default"];
  }
});
Object.defineProperty(exports, "FeedbackListWrapper", {
  enumerable: true,
  get: function get() {
    return _feedback_list_wrapper["default"];
  }
});
Object.defineProperty(exports, "FilterDateWrapper", {
  enumerable: true,
  get: function get() {
    return _filter_date_wrapper["default"];
  }
});
Object.defineProperty(exports, "FilterNumberWrapper", {
  enumerable: true,
  get: function get() {
    return _filter_number_wrapper["default"];
  }
});
Object.defineProperty(exports, "FilterTagsWrapper", {
  enumerable: true,
  get: function get() {
    return _filter_tags_wrapper["default"];
  }
});
Object.defineProperty(exports, "FlagButtonWrapper", {
  enumerable: true,
  get: function get() {
    return _flag_button_wrapper["default"];
  }
});
Object.defineProperty(exports, "FollowingIndexWrapper", {
  enumerable: true,
  get: function get() {
    return _following_index_wrapper["default"];
  }
});
Object.defineProperty(exports, "FrequencyWrapper", {
  enumerable: true,
  get: function get() {
    return _frequency_wrapper["default"];
  }
});
Object.defineProperty(exports, "GenderCardWrapper", {
  enumerable: true,
  get: function get() {
    return _gender_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "GoToCardWrapper", {
  enumerable: true,
  get: function get() {
    return _go_to_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "GrammarDescriptionFlagWrapper", {
  enumerable: true,
  get: function get() {
    return _grammar_description_flag_wrapper["default"];
  }
});
Object.defineProperty(exports, "GrammarIndexWrapper", {
  enumerable: true,
  get: function get() {
    return _grammar_index_wrapper["default"];
  }
});
Object.defineProperty(exports, "GrammarTreeNodeShowWrapper", {
  enumerable: true,
  get: function get() {
    return _grammar_tree_node_show_wrapper["default"];
  }
});
Object.defineProperty(exports, "GrammarWrapper", {
  enumerable: true,
  get: function get() {
    return _grammar_wrapper["default"];
  }
});
Object.defineProperty(exports, "HeaderWrapper", {
  enumerable: true,
  get: function get() {
    return _header_wrapper["default"];
  }
});
Object.defineProperty(exports, "HelpCenterWrapper", {
  enumerable: true,
  get: function get() {
    return _help_center_wrapper["default"];
  }
});
Object.defineProperty(exports, "InterjectionCardWrapper", {
  enumerable: true,
  get: function get() {
    return _interjection_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "LanguageFilterWrapper", {
  enumerable: true,
  get: function get() {
    return _language_filter_wrapper["default"];
  }
});
Object.defineProperty(exports, "LanguageIconWrapper", {
  enumerable: true,
  get: function get() {
    return _language_icon_wrapper["default"];
  }
});
Object.defineProperty(exports, "LanguagePreferenceCardWrapper", {
  enumerable: true,
  get: function get() {
    return _language_preference_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "LeaderboardWrapper", {
  enumerable: true,
  get: function get() {
    return _leaderboard_wrapper["default"];
  }
});
Object.defineProperty(exports, "LeagueHistoryWrapper", {
  enumerable: true,
  get: function get() {
    return _league_history_wrapper["default"];
  }
});
Object.defineProperty(exports, "LeaguePreviewWrapper", {
  enumerable: true,
  get: function get() {
    return _league_preview_wrapper["default"];
  }
});
Object.defineProperty(exports, "LeagueRankWrapper", {
  enumerable: true,
  get: function get() {
    return _league_rank_wrapper["default"];
  }
});
Object.defineProperty(exports, "LeagueShowWrapper", {
  enumerable: true,
  get: function get() {
    return _league_show_wrapper["default"];
  }
});
Object.defineProperty(exports, "LeagueTableWrapper", {
  enumerable: true,
  get: function get() {
    return _league_table_wrapper["default"];
  }
});
Object.defineProperty(exports, "LearnedButtonWrapper", {
  enumerable: true,
  get: function get() {
    return _learned_button_wrapper["default"];
  }
});
Object.defineProperty(exports, "LearnedIconWrapper", {
  enumerable: true,
  get: function get() {
    return _learned_icon_wrapper["default"];
  }
});
Object.defineProperty(exports, "MediaSectionWrapper", {
  enumerable: true,
  get: function get() {
    return _media_section_wrapper["default"];
  }
});
Object.defineProperty(exports, "MediaWithSupplementWrapper", {
  enumerable: true,
  get: function get() {
    return _media_with_supplement_wrapper["default"];
  }
});
Object.defineProperty(exports, "ModuleWrapper", {
  enumerable: true,
  get: function get() {
    return _module_wrapper["default"];
  }
});
Object.defineProperty(exports, "MultipleChoiceButtonsWrapper", {
  enumerable: true,
  get: function get() {
    return _multiple_choice_buttons_wrapper["default"];
  }
});
Object.defineProperty(exports, "NameWithIconsWrapper", {
  enumerable: true,
  get: function get() {
    return _name_with_icons_wrapper["default"];
  }
});
Object.defineProperty(exports, "NumberCardWrapper", {
  enumerable: true,
  get: function get() {
    return _number_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "OnboardingChooseDeckWrapper", {
  enumerable: true,
  get: function get() {
    return _onboarding_choose_deck_wrapper["default"];
  }
});
Object.defineProperty(exports, "OnboardingIllustrationWrapper", {
  enumerable: true,
  get: function get() {
    return _onboarding_illustration_wrapper["default"];
  }
});
Object.defineProperty(exports, "OnboardingLevelWrapper", {
  enumerable: true,
  get: function get() {
    return _onboarding_level_wrapper["default"];
  }
});
Object.defineProperty(exports, "OnboardingNativeLanguageWrapper", {
  enumerable: true,
  get: function get() {
    return _onboarding_native_language_wrapper["default"];
  }
});
Object.defineProperty(exports, "OnboardingReferrerWrapper", {
  enumerable: true,
  get: function get() {
    return _onboarding_referrer_wrapper["default"];
  }
});
Object.defineProperty(exports, "OnboardingRegistrationWrapper", {
  enumerable: true,
  get: function get() {
    return _onboarding_registration_wrapper["default"];
  }
});
Object.defineProperty(exports, "OnboardingWrapper", {
  enumerable: true,
  get: function get() {
    return _onboarding_wrapper["default"];
  }
});
Object.defineProperty(exports, "PaginatorWrapper", {
  enumerable: true,
  get: function get() {
    return _paginator_wrapper["default"];
  }
});
Object.defineProperty(exports, "PartnersWrapper", {
  enumerable: true,
  get: function get() {
    return _partners_wrapper["default"];
  }
});
Object.defineProperty(exports, "PluralCardWrapper", {
  enumerable: true,
  get: function get() {
    return _plural_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "PointsBarWrapper", {
  enumerable: true,
  get: function get() {
    return _points_bar_wrapper["default"];
  }
});
Object.defineProperty(exports, "ProfileHomeWrapper", {
  enumerable: true,
  get: function get() {
    return _profile_home_wrapper["default"];
  }
});
Object.defineProperty(exports, "PronunciationCardWrapper", {
  enumerable: true,
  get: function get() {
    return _pronunciation_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "ReorderAcceptItemWrapper", {
  enumerable: true,
  get: function get() {
    return _reorder_accept_item_wrapper["default"];
  }
});
Object.defineProperty(exports, "ReportBugWrapper", {
  enumerable: true,
  get: function get() {
    return _report_bug_wrapper["default"];
  }
});
Object.defineProperty(exports, "ReportMeaningsWrapper", {
  enumerable: true,
  get: function get() {
    return _report_meanings_wrapper["default"];
  }
});
Object.defineProperty(exports, "ResultsCardWrapper", {
  enumerable: true,
  get: function get() {
    return _results_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "ReviewChangeCardTypeWrapper", {
  enumerable: true,
  get: function get() {
    return _review_change_card_type_wrapper["default"];
  }
});
Object.defineProperty(exports, "ReviewCreateWrapper", {
  enumerable: true,
  get: function get() {
    return _review_create_wrapper["default"];
  }
});
Object.defineProperty(exports, "ReviewDeckLinkWrapper", {
  enumerable: true,
  get: function get() {
    return _review_deck_link_wrapper["default"];
  }
});
Object.defineProperty(exports, "ReviewDeckOptionsWrapper", {
  enumerable: true,
  get: function get() {
    return _review_deck_options_wrapper["default"];
  }
});
Object.defineProperty(exports, "ReviewDeckSettingsWrapper", {
  enumerable: true,
  get: function get() {
    return _review_deck_settings_wrapper["default"];
  }
});
Object.defineProperty(exports, "ReviewDecksWrapper", {
  enumerable: true,
  get: function get() {
    return _review_decks_wrapper["default"];
  }
});
Object.defineProperty(exports, "ReviewDetailsWrapper", {
  enumerable: true,
  get: function get() {
    return _review_details_wrapper["default"];
  }
});
Object.defineProperty(exports, "ReviewHistoryTableWrapper", {
  enumerable: true,
  get: function get() {
    return _review_history_table_wrapper["default"];
  }
});
Object.defineProperty(exports, "ReviewHistoryWrapper", {
  enumerable: true,
  get: function get() {
    return _review_history_wrapper["default"];
  }
});
Object.defineProperty(exports, "ReviewHomeWrapper", {
  enumerable: true,
  get: function get() {
    return _review_home_wrapper["default"];
  }
});
Object.defineProperty(exports, "ReviewIndexWrapper", {
  enumerable: true,
  get: function get() {
    return _review_index_wrapper["default"];
  }
});
Object.defineProperty(exports, "ReviewMoveToDeckWrapper", {
  enumerable: true,
  get: function get() {
    return _review_change_card_type_wrapper.ReviewMoveToDeckWrapper;
  }
});
Object.defineProperty(exports, "ReviewToggleWrapper", {
  enumerable: true,
  get: function get() {
    return _review_toggle_wrapper["default"];
  }
});
Object.defineProperty(exports, "SearchInputWrapper", {
  enumerable: true,
  get: function get() {
    return _search_input_wrapper["default"];
  }
});
Object.defineProperty(exports, "SentenceBreakdownItemWrapper", {
  enumerable: true,
  get: function get() {
    return _sentence_breakdown_item_wrapper["default"];
  }
});
Object.defineProperty(exports, "SentenceBreakdownWrapper", {
  enumerable: true,
  get: function get() {
    return _sentence_breakdown_wrapper["default"];
  }
});
Object.defineProperty(exports, "SentenceComprehendCardWrapper", {
  enumerable: true,
  get: function get() {
    return _sentence_comprehend_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "SentenceReportWrapper", {
  enumerable: true,
  get: function get() {
    return _sentence_report_wrapper["default"];
  }
});
Object.defineProperty(exports, "SentenceSubmissionIndexWrapper", {
  enumerable: true,
  get: function get() {
    return _sentence_submission_index_wrapper["default"];
  }
});
Object.defineProperty(exports, "SentenceTranslateCardWrapper", {
  enumerable: true,
  get: function get() {
    return _sentence_translate_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "SettingsBillingWrapper", {
  enumerable: true,
  get: function get() {
    return _settings_billing_wrapper["default"];
  }
});
Object.defineProperty(exports, "SettingsCancelWrapper", {
  enumerable: true,
  get: function get() {
    return _settings_cancel_wrapper["default"];
  }
});
Object.defineProperty(exports, "SettingsClearProgressWrapper", {
  enumerable: true,
  get: function get() {
    return _settings_clear_progress_wrapper["default"];
  }
});
Object.defineProperty(exports, "SettingsStreakRepairWrapper", {
  enumerable: true,
  get: function get() {
    return _settings_streak_repair_wrapper["default"];
  }
});
Object.defineProperty(exports, "SourceEditWrapper", {
  enumerable: true,
  get: function get() {
    return _source_edit_wrapper["default"];
  }
});
Object.defineProperty(exports, "SourceItemWrapper", {
  enumerable: true,
  get: function get() {
    return _source_item_wrapper["default"];
  }
});
Object.defineProperty(exports, "SourceListWithInputWrapper", {
  enumerable: true,
  get: function get() {
    return _source_list_with_input_wrapper["default"];
  }
});
Object.defineProperty(exports, "SourceListWrapper", {
  enumerable: true,
  get: function get() {
    return _source_list_wrapper["default"];
  }
});
Object.defineProperty(exports, "SpecialCharacterButtonsWrapper", {
  enumerable: true,
  get: function get() {
    return _special_character_buttons_wrapper["default"];
  }
});
Object.defineProperty(exports, "StickerReactionWrapper", {
  enumerable: true,
  get: function get() {
    return _sticker_reaction_wrapper["default"];
  }
});
Object.defineProperty(exports, "StoriesDeckLinkWrapper", {
  enumerable: true,
  get: function get() {
    return _stories_deck_link_wrapper["default"];
  }
});
Object.defineProperty(exports, "SynonymCardWrapper", {
  enumerable: true,
  get: function get() {
    return _synonym_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "TabWrapper", {
  enumerable: true,
  get: function get() {
    return _tab_wrapper["default"];
  }
});
Object.defineProperty(exports, "TextResizerWrapper", {
  enumerable: true,
  get: function get() {
    return _text_resizer_wrapper["default"];
  }
});
Object.defineProperty(exports, "TranslateButtonsWrapper", {
  enumerable: true,
  get: function get() {
    return _translate_buttons_wrapper["default"];
  }
});
Object.defineProperty(exports, "TranslateCardWrapper", {
  enumerable: true,
  get: function get() {
    return _translate_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "TranslationCommentsWrapper", {
  enumerable: true,
  get: function get() {
    return _translation_comments_wrapper["default"];
  }
});
Object.defineProperty(exports, "TranslationWithSourceWrapper", {
  enumerable: true,
  get: function get() {
    return _translation_with_source_wrapper["default"];
  }
});
Object.defineProperty(exports, "TreeNodeDecksWrapper", {
  enumerable: true,
  get: function get() {
    return _tree_node_decks_wrapper["default"];
  }
});
Object.defineProperty(exports, "TreeNodeGrammarWrapper", {
  enumerable: true,
  get: function get() {
    return _tree_node_grammar_wrapper["default"];
  }
});
Object.defineProperty(exports, "TreeNodeIconWrapper", {
  enumerable: true,
  get: function get() {
    return _tree_node_icon_wrapper["default"];
  }
});
Object.defineProperty(exports, "TreeNodeShowWrapper", {
  enumerable: true,
  get: function get() {
    return _tree_node_show_wrapper["default"];
  }
});
Object.defineProperty(exports, "TreeShowWrapper", {
  enumerable: true,
  get: function get() {
    return _tree_show_wrapper["default"];
  }
});
Object.defineProperty(exports, "TriviaCardWrapper", {
  enumerable: true,
  get: function get() {
    return _trivia_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "TriviaDeckLinkWrapper", {
  enumerable: true,
  get: function get() {
    return _trivia_deck_link_wrapper["default"];
  }
});
Object.defineProperty(exports, "TriviaHomeWrapper", {
  enumerable: true,
  get: function get() {
    return _trivia_home_wrapper["default"];
  }
});
Object.defineProperty(exports, "TriviaIntroCardWrapper", {
  enumerable: true,
  get: function get() {
    return _trivia_intro_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "TriviaOpponentsBannerWrapper", {
  enumerable: true,
  get: function get() {
    return _trivia_opponents_banner_wrapper["default"];
  }
});
Object.defineProperty(exports, "TriviaResultsCardWrapper", {
  enumerable: true,
  get: function get() {
    return _trivia_results_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "TriviaResultsWrapper", {
  enumerable: true,
  get: function get() {
    return _trivia_results_wrapper["default"];
  }
});
Object.defineProperty(exports, "UserInputWrapper", {
  enumerable: true,
  get: function get() {
    return _user_input_wrapper["default"];
  }
});
Object.defineProperty(exports, "UserSubmissionCardWrapper", {
  enumerable: true,
  get: function get() {
    return _user_submission_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "VideoPlayerWrapper", {
  enumerable: true,
  get: function get() {
    return _video_player_wrapper["default"];
  }
});
Object.defineProperty(exports, "VocabDecksWrapper", {
  enumerable: true,
  get: function get() {
    return _vocab_decks_wrapper["default"];
  }
});
Object.defineProperty(exports, "VocabOptionsWrapper", {
  enumerable: true,
  get: function get() {
    return _vocab_options_wrapper["default"];
  }
});
Object.defineProperty(exports, "VocabProgressBarWrapper", {
  enumerable: true,
  get: function get() {
    return _vocab_progress_bar_wrapper["default"];
  }
});
Object.defineProperty(exports, "VocabSentencesWrapper", {
  enumerable: true,
  get: function get() {
    return _vocab_sentences_wrapper["default"];
  }
});
Object.defineProperty(exports, "VocabTriadWrapper", {
  enumerable: true,
  get: function get() {
    return _vocab_triad_wrapper["default"];
  }
});
Object.defineProperty(exports, "VocabWordDetailsWrapper", {
  enumerable: true,
  get: function get() {
    return _vocab_word_details_wrapper["default"];
  }
});
Object.defineProperty(exports, "VocabWordWrapper", {
  enumerable: true,
  get: function get() {
    return _vocab_word_wrapper["default"];
  }
});
Object.defineProperty(exports, "VocabWrapper", {
  enumerable: true,
  get: function get() {
    return _vocab_wrapper["default"];
  }
});
Object.defineProperty(exports, "WordBreakdownWrapper", {
  enumerable: true,
  get: function get() {
    return _word_breakdown_wrapper["default"];
  }
});
Object.defineProperty(exports, "WordCardRowExpandedWrapper", {
  enumerable: true,
  get: function get() {
    return _word_card_row_expanded_wrapper["default"];
  }
});
Object.defineProperty(exports, "WordCardWrapper", {
  enumerable: true,
  get: function get() {
    return _word_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "WordComprehendCardWrapper", {
  enumerable: true,
  get: function get() {
    return _word_comprehend_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "WordOptionsCardWrapper", {
  enumerable: true,
  get: function get() {
    return _word_options_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "WordSearchWrapper", {
  enumerable: true,
  get: function get() {
    return _word_search_wrapper["default"];
  }
});
Object.defineProperty(exports, "WordTranslateCardWrapper", {
  enumerable: true,
  get: function get() {
    return _word_translate_card_wrapper["default"];
  }
});
Object.defineProperty(exports, "WorksheetVocabWrapper", {
  enumerable: true,
  get: function get() {
    return _worksheet_vocab_wrapper["default"];
  }
});
Object.defineProperty(exports, "XpAnimationWrapper", {
  enumerable: true,
  get: function get() {
    return _xp_animation_wrapper["default"];
  }
});
Object.defineProperty(exports, "reviewIsPastDue", {
  enumerable: true,
  get: function get() {
    return _review_due_helpers.reviewIsPastDue;
  }
});
Object.defineProperty(exports, "trackMeaningExpansion", {
  enumerable: true,
  get: function get() {
    return _track_meaning_expansion["default"];
  }
});
Object.defineProperty(exports, "useExampleSentenceTranslation", {
  enumerable: true,
  get: function get() {
    return _example_sentence_translation.useExampleSentenceTranslation;
  }
});
var _module_wrapper = _interopRequireDefault(require("./module_wrapper"));
var _sentence_report_wrapper = _interopRequireDefault(require("./sentence_report_wrapper"));
var _track_meaning_expansion = _interopRequireDefault(require("./track_meaning_expansion"));
var _tree_node_icon_wrapper = _interopRequireDefault(require("./tree_node_icon_wrapper"));
var _tree_node_show_wrapper = _interopRequireDefault(require("./tree_node_show_wrapper"));
var _tree_show_wrapper = _interopRequireDefault(require("./tree_show_wrapper"));
var _deck_link_wrapper = _interopRequireDefault(require("./deck_link_wrapper"));
var _review_home_wrapper = _interopRequireDefault(require("./review_home_wrapper"));
var _vocab_wrapper = _interopRequireDefault(require("./vocab_wrapper"));
var _frequency_wrapper = _interopRequireDefault(require("./frequency_wrapper"));
var _vocab_progress_bar_wrapper = _interopRequireDefault(require("./vocab_progress_bar_wrapper"));
var _paginator_wrapper = _interopRequireDefault(require("./paginator_wrapper"));
var _vocab_word_wrapper = _interopRequireDefault(require("./vocab_word_wrapper"));
var _video_player_wrapper = _interopRequireWildcard(require("./video_player_wrapper"));
var _source_list_with_input_wrapper = _interopRequireDefault(require("./source_list_with_input_wrapper"));
var _source_list_wrapper = _interopRequireDefault(require("./source_list_wrapper"));
var _tab_wrapper = _interopRequireDefault(require("./tab_wrapper"));
var _word_breakdown_wrapper = _interopRequireDefault(require("./word_breakdown_wrapper"));
var _sentence_breakdown_wrapper = _interopRequireDefault(require("./sentence_breakdown_wrapper"));
var _sentence_breakdown_item_wrapper = _interopRequireDefault(require("./sentence_breakdown_item_wrapper"));
var _sentence_submission_index_wrapper = _interopRequireDefault(require("./sentence_submission_index_wrapper"));
var _conjugation_table_wrapper = _interopRequireDefault(require("./conjugation_table_wrapper"));
var _comment_index_wrapper = _interopRequireDefault(require("./comment_index_wrapper"));
var _comment_show_wrapper = _interopRequireDefault(require("./comment_show_wrapper"));
var _comment_create_wrapper = _interopRequireDefault(require("./comment_create_wrapper"));
var _translation_comments_wrapper = _interopRequireDefault(require("./translation_comments_wrapper"));
var _review_create_wrapper = _interopRequireDefault(require("./review_create_wrapper"));
var _badge_wrapper = _interopRequireDefault(require("./badge_wrapper"));
var _badge_collection_wrapper = _interopRequireDefault(require("./badge_collection_wrapper"));
var _deck_progress_bar_wrapper = _interopRequireDefault(require("./deck_progress_bar_wrapper"));
var _deck_menu_wrapper = _interopRequireDefault(require("./deck_menu_wrapper"));
var _card_button_wrapper = _interopRequireDefault(require("./card_button_wrapper"));
var _trivia_card_wrapper = _interopRequireDefault(require("./trivia_card_wrapper"));
var _trivia_intro_card_wrapper = _interopRequireDefault(require("./trivia_intro_card_wrapper"));
var _correct_cards_status_wrapper = _interopRequireDefault(require("./correct_cards_status_wrapper"));
var _multiple_choice_buttons_wrapper = _interopRequireDefault(require("./multiple_choice_buttons_wrapper"));
var _trivia_results_wrapper = _interopRequireDefault(require("./trivia_results_wrapper"));
var _card_text_wrapper = _interopRequireDefault(require("./card_text_wrapper"));
var _text_resizer_wrapper = _interopRequireDefault(require("./text_resizer_wrapper"));
var _points_bar_wrapper = _interopRequireDefault(require("./points_bar_wrapper"));
var _trivia_results_card_wrapper = _interopRequireDefault(require("./trivia_results_card_wrapper"));
var _word_card_wrapper = _interopRequireDefault(require("./word_card_wrapper"));
var _word_card_row_expanded_wrapper = _interopRequireDefault(require("./word_card_row_expanded_wrapper"));
var _checkpoint_card_wrapper = _interopRequireDefault(require("./checkpoint_card_wrapper"));
var _sentence_translate_card_wrapper = _interopRequireDefault(require("./sentence_translate_card_wrapper"));
var _media_section_wrapper = _interopRequireDefault(require("./media_section_wrapper"));
var _deck_summary_card_wrapper = _interopRequireDefault(require("./deck_summary_card_wrapper"));
var _deck_wrapper = _interopRequireDefault(require("./deck_wrapper"));
var _media_with_supplement_wrapper = _interopRequireDefault(require("./media_with_supplement_wrapper"));
var _user_input_wrapper = _interopRequireDefault(require("./user_input_wrapper"));
var _card_source_list_wrapper = _interopRequireDefault(require("./card_source_list_wrapper"));
var _deck_settings_wrapper = _interopRequireDefault(require("./deck_settings_wrapper"));
var _report_meanings_wrapper = _interopRequireDefault(require("./report_meanings_wrapper"));
var _deck_rating_wrapper = _interopRequireDefault(require("./deck_rating_wrapper"));
var _card_section_wrapper = _interopRequireDefault(require("./card_section_wrapper"));
var _word_options_card_wrapper = _interopRequireDefault(require("./word_options_card_wrapper"));
var _word_translate_card_wrapper = _interopRequireDefault(require("./word_translate_card_wrapper"));
var _border_radius = _interopRequireDefault(require("./border_radius"));
var _language_preference_card_wrapper = _interopRequireDefault(require("./language_preference_card_wrapper"));
var _feed_info_wrapper = _interopRequireDefault(require("./feed_info_wrapper"));
var _feed_entry_index_wrapper = _interopRequireDefault(require("./feed_entry_index_wrapper"));
var _feed_entry_wrapper = _interopRequireDefault(require("./feed_entry_wrapper"));
var _composite_video_player_wrapper = _interopRequireDefault(require("./composite_video_player_wrapper"));
var _results_card_wrapper = _interopRequireDefault(require("./results_card_wrapper"));
var _deck_close_native_wrapper = _interopRequireDefault(require("./deck_close_native_wrapper"));
var _deck_close_web_wrapper = _interopRequireDefault(require("./deck_close_web_wrapper"));
var _arrow_box_wrapper = _interopRequireDefault(require("./arrow_box_wrapper"));
var _card_icons_wrapper = _interopRequireDefault(require("./card_icons_wrapper"));
var _profile_home_wrapper = _interopRequireDefault(require("./profile_home_wrapper"));
var _faq_wrapper = _interopRequireDefault(require("./faq_wrapper"));
var _partners_wrapper = _interopRequireDefault(require("./partners_wrapper"));
var _exercise_match_media_wrapper = _interopRequireDefault(require("./exercise_match_media_wrapper"));
var _exercise_multiple_choice_media_wrapper = _interopRequireDefault(require("./exercise_multiple_choice_media_wrapper"));
var _xp_animation_wrapper = _interopRequireDefault(require("./xp_animation_wrapper"));
var _gender_card_wrapper = _interopRequireDefault(require("./gender_card_wrapper"));
var _plural_card_wrapper = _interopRequireDefault(require("./plural_card_wrapper"));
var _synonym_card_wrapper = _interopRequireDefault(require("./synonym_card_wrapper"));
var _evaluate_buttons_wrapper = _interopRequireDefault(require("./evaluate_buttons_wrapper"));
var _exercise_card_wrapper = _interopRequireDefault(require("./exercise_card_wrapper"));
var _exercise_reorder_wrapper = _interopRequireDefault(require("./exercise_reorder_wrapper"));
var _interjection_card_wrapper = _interopRequireDefault(require("./interjection_card_wrapper"));
var _comprehend_card_wrapper = _interopRequireDefault(require("./comprehend_card_wrapper"));
var _translate_card_wrapper = _interopRequireDefault(require("./translate_card_wrapper"));
var _answer_card_wrapper = _interopRequireDefault(require("./answer_card_wrapper"));
var _describe_card_wrapper = _interopRequireDefault(require("./describe_card_wrapper"));
var _translate_buttons_wrapper = _interopRequireDefault(require("./translate_buttons_wrapper"));
var _card_arrow_box_wrapper = _interopRequireDefault(require("./card_arrow_box_wrapper"));
var _report_bug_wrapper = _interopRequireDefault(require("./report_bug_wrapper"));
var _word_comprehend_card_wrapper = _interopRequireDefault(require("./word_comprehend_card_wrapper"));
var _card_word_text_wrapper = _interopRequireDefault(require("./card_word_text_wrapper"));
var _sentence_comprehend_card_wrapper = _interopRequireDefault(require("./sentence_comprehend_card_wrapper"));
var _card_user_input_wrapper = _interopRequireDefault(require("./card_user_input_wrapper"));
var _feedback_list_wrapper = _interopRequireDefault(require("./feedback_list_wrapper"));
var _vocab_sentences_wrapper = _interopRequireDefault(require("./vocab_sentences_wrapper"));
var _language_filter_wrapper = _interopRequireDefault(require("./language_filter_wrapper"));
var _audio_player_wrapper = _interopRequireDefault(require("./audio_player_wrapper"));
var _stories_deck_link_wrapper = _interopRequireDefault(require("./stories_deck_link_wrapper"));
var _vocab_decks_wrapper = _interopRequireDefault(require("./vocab_decks_wrapper"));
var _vocab_options_wrapper = _interopRequireDefault(require("./vocab_options_wrapper"));
var _trivia_deck_link_wrapper = _interopRequireDefault(require("./trivia_deck_link_wrapper"));
var _trivia_opponents_banner_wrapper = _interopRequireDefault(require("./trivia_opponents_banner_wrapper"));
var _content_link_wrapper = _interopRequireDefault(require("./content_link_wrapper"));
var _tree_node_grammar_wrapper = _interopRequireDefault(require("./tree_node_grammar_wrapper"));
var _settings_billing_wrapper = _interopRequireDefault(require("./settings_billing_wrapper"));
var _account_deletion_confirmation_wrapper = _interopRequireDefault(require("./account_deletion_confirmation_wrapper"));
var _settings_cancel_wrapper = _interopRequireDefault(require("./settings_cancel_wrapper"));
var _settings_streak_repair_wrapper = _interopRequireDefault(require("./settings_streak_repair_wrapper"));
var _daily_activity_wrapper = _interopRequireDefault(require("./daily_activity_wrapper"));
var _daily_activity_calendar_day_wrapper = _interopRequireDefault(require("./daily_activity_calendar_day_wrapper"));
var _word_search_wrapper = _interopRequireDefault(require("./word_search_wrapper"));
var _search_input_wrapper = _interopRequireDefault(require("./search_input_wrapper"));
var _leaderboard_wrapper = _interopRequireDefault(require("./leaderboard_wrapper"));
var _following_index_wrapper = _interopRequireDefault(require("./following_index_wrapper"));
var _user_submission_card_wrapper = _interopRequireDefault(require("./user_submission_card_wrapper"));
var _review_decks_wrapper = _interopRequireDefault(require("./review_decks_wrapper"));
var _review_deck_settings_wrapper = _interopRequireDefault(require("./review_deck_settings_wrapper"));
var _review_deck_options_wrapper = _interopRequireDefault(require("./review_deck_options_wrapper"));
var _review_deck_link_wrapper = _interopRequireDefault(require("./review_deck_link_wrapper"));
var _review_index_wrapper = _interopRequireDefault(require("./review_index_wrapper"));
var _bulk_edit_reviews_wrapper = _interopRequireDefault(require("./bulk_edit_reviews_wrapper"));
var _card_type_select_wrapper = _interopRequireDefault(require("./card_type_select_wrapper"));
var _filter_date_wrapper = _interopRequireDefault(require("./filter_date_wrapper"));
var _filter_number_wrapper = _interopRequireDefault(require("./filter_number_wrapper"));
var _review_toggle_wrapper = _interopRequireDefault(require("./review_toggle_wrapper"));
var _learned_button_wrapper = _interopRequireDefault(require("./learned_button_wrapper"));
var _faq_category_show_wrapper = _interopRequireDefault(require("./faq_category_show_wrapper"));
var _faq_item_show_wrapper = _interopRequireDefault(require("./faq_item_show_wrapper"));
var _help_center_wrapper = _interopRequireDefault(require("./help_center_wrapper"));
var _card_review_toggle_wrapper = _interopRequireDefault(require("./card_review_toggle_wrapper"));
var _review_change_card_type_wrapper = _interopRequireWildcard(require("./review_change_card_type_wrapper"));
var _review_details_wrapper = _interopRequireDefault(require("./review_details_wrapper"));
var _review_history_wrapper = _interopRequireDefault(require("./review_history_wrapper"));
var _review_history_table_wrapper = _interopRequireDefault(require("./review_history_table_wrapper"));
var _card_note_wrapper = _interopRequireDefault(require("./card_note_wrapper"));
var _conjugation_card_wrapper = _interopRequireDefault(require("./conjugation_card_wrapper"));
var _conjugation_card_prompt_wrapper = _interopRequireDefault(require("./conjugation_card_prompt_wrapper"));
var _conjugation_table_card_wrapper = _interopRequireDefault(require("./conjugation_table_card_wrapper"));
var _translation_with_source_wrapper = _interopRequireDefault(require("./translation_with_source_wrapper"));
var _vocab_triad_wrapper = _interopRequireDefault(require("./vocab_triad_wrapper"));
var _trivia_home_wrapper = _interopRequireDefault(require("./trivia_home_wrapper"));
var _conjugation_card_revealed_wrapper = _interopRequireDefault(require("./conjugation_card_revealed_wrapper"));
var _reorder_accept_item_wrapper = _interopRequireDefault(require("./reorder_accept_item_wrapper"));
var _sticker_reaction_wrapper = _interopRequireDefault(require("./sticker_reaction_wrapper"));
var _header_wrapper = _interopRequireDefault(require("./header_wrapper"));
var _filter_tags_wrapper = _interopRequireDefault(require("./filter_tags_wrapper"));
var _number_card_wrapper = _interopRequireDefault(require("./number_card_wrapper"));
var _grammar_wrapper = _interopRequireDefault(require("./grammar_wrapper"));
var _grammar_tree_node_show_wrapper = _interopRequireDefault(require("./grammar_tree_node_show_wrapper"));
var _grammar_index_wrapper = _interopRequireDefault(require("./grammar_index_wrapper"));
var _tree_node_decks_wrapper = _interopRequireDefault(require("./tree_node_decks_wrapper"));
var _exercise_create_wrapper = _interopRequireDefault(require("./exercise_create_wrapper"));
var _pronunciation_card_wrapper = _interopRequireDefault(require("./pronunciation_card_wrapper"));
var _special_character_buttons_wrapper = _interopRequireDefault(require("./special_character_buttons_wrapper"));
var _settings_clear_progress_wrapper = _interopRequireDefault(require("./settings_clear_progress_wrapper"));
var _worksheet_vocab_wrapper = _interopRequireDefault(require("./worksheet_vocab_wrapper"));
var _advanced_filters_wrapper = _interopRequireDefault(require("./advanced_filters_wrapper"));
var _onboarding_wrapper = _interopRequireDefault(require("./onboarding_wrapper"));
var _onboarding_level_wrapper = _interopRequireDefault(require("./onboarding_level_wrapper"));
var _onboarding_native_language_wrapper = _interopRequireDefault(require("./onboarding_native_language_wrapper"));
var _onboarding_registration_wrapper = _interopRequireDefault(require("./onboarding_registration_wrapper"));
var _onboarding_referrer_wrapper = _interopRequireDefault(require("./onboarding_referrer_wrapper"));
var _onboarding_choose_deck_wrapper = _interopRequireDefault(require("./onboarding_choose_deck_wrapper"));
var _animated_progress_bar_wrapper = _interopRequireDefault(require("./animated_progress_bar_wrapper"));
var _onboarding_illustration_wrapper = _interopRequireDefault(require("./onboarding_illustration_wrapper"));
var _source_edit_wrapper = _interopRequireDefault(require("./source_edit_wrapper"));
var _source_item_wrapper = _interopRequireDefault(require("./source_item_wrapper"));
var _flag_button_wrapper = _interopRequireDefault(require("./flag_button_wrapper"));
var _language_icon_wrapper = _interopRequireDefault(require("./language_icon_wrapper"));
var _league_show_wrapper = _interopRequireDefault(require("./league_show_wrapper"));
var _league_preview_wrapper = _interopRequireDefault(require("./league_preview_wrapper"));
var _league_history_wrapper = _interopRequireDefault(require("./league_history_wrapper"));
var _league_rank_wrapper = _interopRequireDefault(require("./league_rank_wrapper"));
var _league_table_wrapper = _interopRequireDefault(require("./league_table_wrapper"));
var _name_with_icons_wrapper = _interopRequireDefault(require("./name_with_icons_wrapper"));
var _banner_notices_index_wrapper = _interopRequireDefault(require("./banner_notices_index_wrapper"));
var _banner_notices_show_wrapper = _interopRequireDefault(require("./banner_notices_show_wrapper"));
var _case_multiple_choice_card_wrapper = _interopRequireDefault(require("./case_multiple_choice_card_wrapper"));
var _case_fill_in_the_blanks_card_wrapper = _interopRequireDefault(require("./case_fill_in_the_blanks_card_wrapper"));
var _case_intro_card_wrapper = _interopRequireDefault(require("./case_intro_card_wrapper"));
var _learned_icon_wrapper = _interopRequireDefault(require("./learned_icon_wrapper"));
var _go_to_card_wrapper = _interopRequireDefault(require("./go_to_card_wrapper"));
var _review_due_helpers = require("./review_due_helpers");
var _comment_history_wrapper = _interopRequireDefault(require("./comment_history_wrapper"));
var _deck_history_wrapper = _interopRequireDefault(require("./deck_history_wrapper"));
var _example_sentence_translation = require("./example_sentence_translation");
var _dictionary_sentences_wrapper = _interopRequireDefault(require("./dictionary_sentences_wrapper"));
var _vocab_word_details_wrapper = _interopRequireDefault(require("./vocab_word_details_wrapper"));
var _grammar_description_flag_wrapper = _interopRequireDefault(require("./grammar_description_flag_wrapper"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }